import { render } from "./ModalHelperScroll.vue?vue&type=template&id=29b2bac6&scoped=true"
import script from "./ModalHelperScroll.vue?vue&type=script&lang=js"
export * from "./ModalHelperScroll.vue?vue&type=script&lang=js"

import "./ModalHelperScroll.vue?vue&type=style&index=0&id=29b2bac6&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b2bac6"]])

export default __exports__